import React from 'react';
import cx from 'classnames';

import { pluralize } from 'utilities/pluralize';

import { WhiteButton } from '@marketing/components/buttons';
import UnderlinedText from '@marketing/components/underlined_text';

import marketingStyles from '@marketing/style.module.scss';
import styles from './style.module.scss';

interface Props {
  pointIncrease?: number | string;
}

export default (props) => {
  const pointIncreaseText = typeof props.pointIncrease === 'string' ? (
    props.pointIncrease
  ) : (
    pluralize(props.pointIncrease, 'point')
  );

  return (
    <div
      className={cx(styles.guaranteeContainer, marketingStyles.greenNoiseBg)}
      style={{
        borderRadius: 20,
        boxShadow: '0 6px 6px -3px rgba(0, 0, 0, 0.07), 0 2px 2px -1px rgba(0, 0, 0, 0.07)'
      }}
    >
      <div className="d-flex flex-column gap-l">
        <div>
          <h3 className={cx(styles.header, 'text-center u-margin-A-n')} style={{ color: '#FFFFFF' }}
          >
            <strong>Score {props.pointIncrease ? pointIncreaseText : ''} higher or get your money back. Try it <UnderlinedText color="#ffffff" flip>risk-free for 7 days.</UnderlinedText></strong>
          </h3>
        </div>

        <div className="text-center">
          <WhiteButton href="/plans#offers">Explore Our Plans</WhiteButton>
        </div>
      </div>
    </div>
  );
};
